// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useEffect, useRef } from "react";
import { useAnimation } from "../hooks/useAnimation";
import { NavLink } from "react-router-dom";
import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { CITIES } from "../constants";
import Select from 'react-select'
import cx from "classnames";



const PAYMENT_OPTIONS = [
    {
        nane: 'Kredi Kartı (İnternetten Ödeme)',
        value: 'Kredi-Kartı-İnternetten-Ödeme',
        label: 'Kredi Kartı (İnternetten Ödeme)'
    },
    {
        nane: 'Kredi Kartı (Kapıda Ödeme)',
        value: 'Kredi-Kartı-Kapıda-Ödeme',
        label: 'Kredi Kartı (Kapıda Ödeme)'
    },
    {
        name: 'Nakit',
        value: 'Nakit',
        label: 'Nakit'
    },
    {
        name: 'Setcard Mobil Ödeme',
        value: 'Setcard-Mobil-Odeme',
        label: 'Setcard Mobil Ödeme'
    },
    {
        name: 'Ticket Mobil Ödeme',
        value: 'Ticket-Mobil-Odeme',
        label: 'Ticket Mobil Ödeme'
    },
    {
        name: 'Multinet Mobil Ödeme',
        value: 'Multinet-Mobil-Odeme',
        label: 'Multinet Mobil Ödeme'
    },
    {
        name: 'Sodexo Mobil Ödeme',
        value: 'Sodexo-Mobil-Ödeme',
        label: 'Sodexo Mobil Ödeme'
    },
    {
        name: 'Metropol Mobil',
        value: 'Metropol-Mobil',
        label: 'Metropol Mobil'
    },
    {
        name: 'Metropol',
        value: 'Metropol',
        label: 'Metropol'
    },
    {
        name: 'Smart Ticket',
        value: 'Smart-Ticket',
        label: 'Smart Ticket'
    },
    {
        name: 'Multinet',
        value: 'Multinet',
        label: 'Multinet'
    },
    {
        name: 'TicketKart',
        value: 'TicketKart',
        label: 'TicketKart'
    },
    {
        name: 'Paye Card',
        value: 'Paye-Card',
        label: 'Paye Card'
    },
    {
        name: 'SodexoKart',
        value: 'SodexoKart',
        label: 'SodexoKart'
    },
    {
        name: 'Set Card',
        value: 'Set-Card',
        label: 'Set Card'
    },
]

const KITCHEN_TYPES = [
    {
        name: 'Burger',
        value: 'Burger',
        label: 'Burger'
    },
    {
        name: 'Döner',
        value: 'Döner',
        label: 'Döner'
    },
    {
        name: 'Kebap',
        value: 'Kebap',
        label: 'Kebap'
    },
    {
        name: 'Pizza',
        value: 'Pizza',
        label: 'Pizza'
    },
    {
        name: 'Tavuk',
        value: 'Tavuk',
        label: 'Tavuk'
    },
    {
        name: 'Mantı & Makarna',
        value: 'Mantı & Makarna',
        label: 'Mantı & Makarna'
    },
    {
        name: 'Salata & Sağlıklı Yemek',
        value: 'Salata & Sağlıklı Yemek',
        label: 'Salata & Sağlıklı Yemek'
    },
    {
        name: 'Tatlı',
        value: 'Tatlı',
        label: 'Tatlı'
    },
    {
        name: 'Dondurma',
        value: 'Dondurma',
        label: 'Dondurma'
    },
    {
        name: 'Kahvaltı',
        value: 'Kahvaltı',
        label: 'Kahvaltı'
    },
    {
        name: 'Ev Yemekleri',
        value: 'Ev Yemekleri',
        label: 'Ev Yemekleri'
    },
    {
        name: 'Pide & Lahmacu',
        value: 'Pide & Lahmacun',
        label: 'Pide & Lahmacun'
    },
    {
        name: 'Pastane & Fırın',
        value: 'Pastane & Fırın',
        label: 'Pastane & Fırın'
    },
    {
        name: 'Kahve & İçecek',
        value: 'Kahve & İçecek',
        label: 'Kahve & İçecek'
    },
    {
        name: 'Tost & Sandviç',
        value: 'Tost & Sandviç',
        label: 'Tost & Sandviç'
    },
    {
        name: 'Çiğköfte',
        value: 'Çiğköfte',
        label: 'Çiğköfte'
    },
    {
        name: 'Uzak Doğu',
        value: 'Uzak Doğu',
        label: 'Uzak Doğu'
    },
    {
        name: 'Sokak Yemekleri',
        value: 'Sokak Yemekleri',
        label: 'Sokak Yemekleri'
    },
    {
        name: 'Balık & Deniz Ürünleri',
        value: 'Balık & Deniz Ürünleri',
        label: 'Balık & Deniz Ürünleri'
    },
]

const Partner = () => {
    const cityRef = useRef(null);
    const [dateType, setDateType] = useState("text");
    const [userMessenge, setUserMessenge] = useState("text");
    const [errorMessenge, setErrorMessenge] = useState("");
    const [formValid, setFormValid] = useState(false);
    const [tcValid, setTCValid] = useState(true);
    const [showTCMessage, setShowTCMessageset] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(-1);
    const [whereDidYouSeeUs, setWhereDidYouSeeUs] = useState("");
    const animate = useAnimation()

    const [formData, setFormData] = useState({
        sektor: "",
        digerSektor: "",
        markaAdi: "",
        paketSayisi: "",
        kasaSistemi: "",
        mutfakTuru: [],
        odemeYontemleri: [],
        province: "",
        county: "",
        neibourhood: "",
        adres: "",
        isletmeTipi: "",
        subeSayisi: "",
        isletmeAttribute1: "",
        isletmeAttribute2: "",
        kendiKuryenizVarMi: "",
        firstName: "",
        lastName: "",
        gsm: "",
        tc: "",
        email: "",
        cinsiyet: "",
        calismaSekli: "",
        ehliyetTipi: "",
        sirketTipi: "",
        referans: "",
        referansAdSoyad: "",
        gdpr: false,
        kvkk: false,
    });

    const [errors, setErrors] = useState({
        sektor: false,
        digerSektor: false,
        markaAdi: false,
        paketSayisi: false,
        kasaSistemi: false,
        mutfakTuru: false,
        odemeYontemleri: false,
        province: false,
        county: false,
        neibourhood: false,
        adres: false,
        isletmeTipi: false,
        isletmeAttribute1: false,
        isletmeAttribute2: false,
        subeSayisi: false,
        kendiKuryenizVarMi: false,
        firstName: false,
        lastName: false,
        gsm: false,
        tc: false,
        email: false,
        referans: false,
        referansAdSoyad: false,
        gdpr: false,
        kvkk: false,
    });
    // Function to handle input changes
    const handleInputChange = (event) => {

        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });

        if (name === "firstName") {
            formData.firstName = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            event.target.value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        }
        if (name === "lastName") {
            formData.lastName = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            event.target.value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        }
        if (name === "province") {
            if (event.target.value !== "-1") {
                setSelectedDistrict(event.target.value);
            } else {
                setSelectedDistrict(-1);
            }
        }
        if (name === 'gsm') {
            if (formData.gsm[0] === '0') {
                setErrorMessenge("Telefon numaranızı başında 0 olmadan giriniz");
            }
            else {
                setErrorMessenge(null);
            }

            if (name === "province") {
                setSelectedDistrict(event.target.value);

            }

        }

        if (name === 'tc') {
            if (TCValidation(value)) {
                if (!value.includes('_')) {
                    setErrors({ ...errors, tc: true })
                } else {
                    setErrors({ ...errors, tc: false })
                }
            } else {
                setErrors({ ...errors, tc: false })

            }
        }
        if (name === 'isletmeAttribute2') {
            if (TCValidation(value)) {
                if (!value.includes('_')) {
                    setErrors({ ...errors, isletmeAttribute2: true })
                } else {
                    setErrors({ ...errors, isletmeAttribute2: false })
                }
            } else {
                setErrors({ ...errors, isletmeAttribute2: false })

            }
        }
    };

    const TCValidation = (value) => {
        let total = 0;
        for (let i = 0; i < 10; i++) {
            total += parseInt(value[i]);
        }

        if (total % 10 !== parseInt(value[10])) {
            return true;
        }
    }

    const handleSelectChangePayment = (newValue) => {
        formData.odemeYontemleri = newValue.map((item) => item.value);
    }
    const handleSelectChangeKitchen = (newValue) => {
        formData.mutfakTuru = newValue.map((item) => item.value);
    }
    useEffect(() => {
        animate();
        window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (cityRef.current) {
            cityRef.current.children[0].selected = true;
        }
    }, [selectedDistrict]);

    // Function to validate form data
    const validateForm = () => {
        const {
            sektor,
            digerSektor,
            markaAdi,
            paketSayisi,
            kasaSistemi,
            mutfakTuru,
            odemeYontemleri,
            province,
            county,
            neibourhood,
            adres,
            isletmeTipi,
            isletmeAttribute1,
            isletmeAttribute2,
            subeSayisi,
            kendiKuryenizVarMi,
            firstName,
            lastName,
            gsm,
            tc,
            email,
            referans,
            referansAdSoyad,
            gdpr,
            kvkk,
        } = formData;
        // const birthDate = new Date(dogumTarihi);
        // const currentDate = new Date();
        // const age = currentDate.getFullYear() - birthDate.getFullYear();
        let total = 0;
        for (let i = 0; i < 10; i++) {
            total += parseInt(tc[i]);
        }

        const newErrors = {
            sektor: sektor === "" || sektor === "0",
            digerSektor: sektor === "Diğer" && digerSektor.length < 2 || digerSektor.length === "",
            markaAdi: markaAdi.length < 2 || markaAdi.length === "",
            paketSayisi: paketSayisi.length < 1 || paketSayisi.length === "",
            kasaSistemi: kasaSistemi === "" || kasaSistemi === "0",
            mutfakTuru: sektor === "Restoran" && mutfakTuru.length < 1,
            odemeYontemleri: odemeYontemleri.length < 1,
            province: province === "" || province === "0",
            county: county === "" || county === "0",
            neibourhood: neibourhood === "" || neibourhood === "0",
            adres: adres.length < 15 || adres.length === "",
            isletmeTipi: isletmeTipi === "" || isletmeTipi === "0",
            isletmeAttribute1: isletmeTipi === "Kurumsal" && (isletmeAttribute1.length < 10 || isletmeAttribute1.length === ""),
            isletmeAttribute2: isletmeTipi === "Bireysel" && (isletmeAttribute2.length !== 11 || total % 10 !== parseInt(isletmeAttribute2[10])),
            subeSayisi: subeSayisi.length < 1 || subeSayisi.length === "",
            kendiKuryenizVarMi: kendiKuryenizVarMi === "" || kendiKuryenizVarMi === "0",
            firstName: firstName.length < 2 || firstName.length === "",
            lastName: lastName.length < 2 || lastName.length === "",
            gsm: gsm.length < 10 || gsm.includes("_") || gsm[0] === "0",
            tc: tc.length !== 11 || total % 10 !== parseInt(tc[10]),
            email: !/\S+@\S+\.\S+/.test(email),
            referans: referans === "" || referans === "0",
            referansAdSoyad: (referans === "İşletme Referansı" || referans === "Kurye Referansı" || referans === "Satış Temsilcisi") && referansAdSoyad.length < 5 || referansAdSoyad.length === "",
            gdpr: gdpr === false,
            kvkk: kvkk === false,
        };

        setErrors(newErrors);

        return Object.values(newErrors).some((error) => error)
    };



    // Function to handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();
        // Process form data if there are no errors

        if (!validateForm()) {
            // Your submission logic here
            console.log("Form submitted successfully:", formData);
            setFormValid(true);
            window.scrollTo(0, 600);
            alert("Form başarıyla gönderildi");
        } else {
            console.log("Form validation failed:", errors);
            setFormValid(false);
            window.scrollTo(0, 900);
            alert("Form gönderilemedi lütfen eksik alanları doldurunuz");
        }
    }


    return (
        <div className="job-application-form-ctr d-flex justify-content-center flex-column align-items-center">
            <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                <div className="page-banner-third w-100 d-flex justify-content-center align-items-center">
                    <div className="page-container d-flex flex-column justify-content-center align-items-center">
                        <div className="image d-flex justify-content-center align-items-center" data-animation="slideInUp">
                            <img src="/images/business-partner-form.png" alt="" />
                        </div>
                    </div>
                </div>

                <div className="jaf-inner-ctr">
                    <div className="page-container jaf-inner pb-0 d-flex flex-column justify-content-center align-items-center">
                        <div className="jaf-inner-card">
                            <h1 data-animation="zoomIn">
                                İş ortağı olmak istiyorum

                            </h1>
                            <p data-animation="zoomIn">
                                fiyuu ile işbirliği yapmak için ilk adımı atıyorsunuz. Eğer siz de hızlı ve güvenilir teslimatı deneyimlemek isterseniz, başvuru formunu doldurup, işinizin büyümesine katkıda bulunabilirsiniz.
                            </p>
                        </div>
                        <div className="jaf-inner-form w-100">

                            <form
                                onSubmit={handleSubmit}
                                className="w-100 d-flex justify-content-center flex-column align-items-center"
                            >

                                {errorMessenge ? (<div className="warning"> {errorMessenge} </div>) : null}
                                <div className="form-content w-100 row m-0 justify-content-between">
                                    <div className="col-12 col-lg-3 p-0 form-description mb-5 mb-lg-0">
                                        <h3>
                                            Müşteri Bilgileri
                                        </h3>

                                    </div>


                                    <div className="col-12 col-lg-7 p-0 form-items d-flex flex-column">
                                        <div className="form-items">
                                            <div className="form-control-ctr">
                                                <select
                                                    id="sektor"
                                                    name="sektor"
                                                    value={formData.sektor}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.sektor
                                                            ? "error-form-item-select"
                                                            : "form-select"
                                                    }
                                                >
                                                    <option value="0" defaultValue='0'>Sektör *</option>
                                                    <option value="Restoran">Restoran</option>
                                                    <option value="Gıda-Market">Gıda-Market</option>
                                                    <option value="Petshop">Petshop</option>
                                                    <option value="Sağlık">Sağlık</option>
                                                    <option value="Kozmetik">Kozmetik</option>
                                                    <option value="Diğer">Diğer</option>
                                                </select>
                                            </div>
                                            <div className="form-control-ctr">

                                                <input
                                                    type="text"
                                                    placeholder="Marka Adı *"
                                                    id="markaAdi"
                                                    name="markaAdi"
                                                    value={formData.markaAdi}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.markaAdi ? "error-form-item" : "form-control"
                                                    }
                                                />
                                            </div>
                                            {(formData.sektor === "Diğer") && (
                                                <div className="form-control-ctr">

                                                    <input
                                                        type="text"
                                                        placeholder="Sektörū Belirtiniz *"
                                                        id="digerSektor"
                                                        name="digerSektor"
                                                        value={formData.digerSektor}
                                                        onChange={handleInputChange}
                                                        className={
                                                            errors.markaAdi ? "error-form-item" : "form-control"
                                                        }
                                                    />

                                                </div>
                                            )}
                                        </div>

                                        {(formData.sektor === "Restoran") && (
                                            <>

                                                <div style={{ marginTop: ' -20px', marginBottom: ' 20px' }} className="form-control-ctr">
                                                    <select
                                                        id="kasaSistemi"
                                                        name="kasaSistemi"
                                                        value={formData.kasaSistemi}
                                                        onChange={handleInputChange}
                                                        className={
                                                            errors.kasaSistemi
                                                                ? "error-form-item-select"
                                                                : "form-select"
                                                        }
                                                    >
                                                        <option value="0" defaultValue='0'>Kasa Sistemi *</option>
                                                        <option value="Entegre Pos Sistemi">Entegre Pos Sistemi</option>
                                                        <option value="Pc / Laptop">Pc / Laptop</option>
                                                        <option value="Tablet">Tablet</option>
                                                        <option value="Mobil App">Mobil App</option>
                                                    </select>
                                                </div>

                                                <div style={{ marginBottom: ' 20px' }}>
                                                    <Select
                                                        onChange={handleSelectChangeKitchen}
                                                        className={
                                                            errors.mutfakTuru ? "error-form-item-select-multi" : ''}
                                                        placeholder="Mutfak Türü *"

                                                        isMulti
                                                        options={KITCHEN_TYPES}
                                                    />
                                                </div>
                                            </>
                                        )}

                                        <Select
                                            onChange={handleSelectChangePayment}
                                            className={
                                                errors.odemeYontemleri ? "error-form-item-select-multi" : ''}
                                            placeholder="Ödeme Yöntemi *"

                                            isMulti
                                            options={PAYMENT_OPTIONS}
                                        />


                                        <div className="d-flex flex-column flex-sm-row w-100 align-items-stretch">
                                            <div className="form-items flex-column d-flex w-100 w-sm-50 me-4 mb-sm-0">
                                                <div className="form-control-ctr">
                                                    <select
                                                        id="province"
                                                        name="province"
                                                        value={formData.province}
                                                        className={
                                                            errors.province ? "error-form-item-select" : "form-select"
                                                        }
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value={-1}> İl Seçiniz *</option>
                                                        {CITIES.map((city, index) => (
                                                            <option key={index} value={index}>
                                                                {city.province}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-control-ctr">
                                                    <select
                                                        id="county"
                                                        name="county"
                                                        value={formData.county}
                                                        onChange={handleInputChange}
                                                        className={
                                                            errors.county
                                                                ? "error-form-item-select"
                                                                : "form-select"
                                                        }
                                                        disabled={selectedDistrict === -1}
                                                        ref={cityRef}
                                                    >
                                                        <option value="0" defaultValue="0">
                                                            İlçe Seçiniz *
                                                        </option>
                                                        {selectedDistrict !== -1 &&
                                                            CITIES[selectedDistrict].ilceleri.map(
                                                                (county, index) => (
                                                                    <option key={index} value={county}>
                                                                        {county}
                                                                    </option>
                                                                )
                                                            )}
                                                    </select>
                                                </div>

                                            </div>
                                            <div className="form-control-ctr w-100 w-sm-50 ms-sm-2 h-auto">
                                                <textarea
                                                    id="adres"
                                                    name="adres"
                                                    value={formData.adres}
                                                    maxLength="500"
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.adres ? "error-form-item h-100" : "form-control h-100"
                                                    }

                                                    placeholder="Adres *"></textarea>
                                            </div>
                                        </div>
                                        <div className="form-items">
                                            <div className="form-control-ctr">
                                                <select
                                                    id="neibourhood"
                                                    name="neibourhood"
                                                    value={formData.neibourhood}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.neibourhood
                                                            ? "error-form-item-select"
                                                            : "form-select"
                                                    }

                                                >
                                                    <option value="0" defaultValue="0">
                                                        Mahalle Seçiniz *
                                                    </option>
                                                    <option value="1">
                                                        Mahalle 1
                                                    </option>
                                                    <option value="2">
                                                        Mahalle 2
                                                    </option>
                                                </select>
                                            </div>
                                            <div className="form-control-ctr">

                                                <input
                                                    type="number"
                                                    min={1}
                                                    placeholder="Günlük Ort. Paket Siparişi *"
                                                    id="paketSayisi"
                                                    name="paketSayisi"
                                                    value={formData.paketSayisi}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.paketSayisi ? "error-form-item" : "form-control"
                                                    }
                                                />
                                            </div>
                                            <div className="form-control-ctr">
                                                <select
                                                    id="isletmeTipi"
                                                    name="isletmeTipi"
                                                    value={formData.isletmeTipi}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.isletmeTipi
                                                            ? "error-form-item-select"
                                                            : "form-select"
                                                    }
                                                >
                                                    <option value="0" defaultValue='0'>İşletme tipi *</option>
                                                    <option value="Kurumsal">Kurumsal</option>
                                                    <option value="Bireysel">Bireysel</option>
                                                </select>
                                            </div>
                                            <div className="form-control-ctr ">
                                                {(formData.isletmeTipi === "Kurumsal") && (

                                                    <input
                                                        type="text"
                                                        placeholder="Vergi No *"
                                                        id="isletmeAttribute1"
                                                        name="isletmeAttribute1"
                                                        value={formData.isletmeAttribute1}
                                                        onChange={handleInputChange}
                                                        className={
                                                            errors.isletmeAttribute1 ? "error-form-item" : "form-control"
                                                        }
                                                    />

                                                )}
                                                {(formData.isletmeTipi === "Bireysel") && (
                                                    <>
                                                        <InputMask
                                                            type="tckn"
                                                            mask="99999999999"
                                                            placeholder="TC Kimlik No *"
                                                            id="isletmeAttribute2"
                                                            name="isletmeAttribute2"
                                                            value={formData.isletmeAttribute2}
                                                            onChange={handleInputChange}
                                                            className={
                                                                errors.isletmeAttribute2 ? "error-form-item" : "form-control"
                                                            }
                                                        />
                                                        {errors.isletmeAttribute2 && <small className="error-text">Geçersiz Kimlik Numarası</small>}
                                                    </>
                                                )}
                                            </div>

                                            <div className="form-control-ctr">
                                                <input type="number" min={1} placeholder="Şube sayısı *" id="subeSayisi" name="subeSayisi" value={formData.subeSayisi} onChange={handleInputChange} className={errors.subeSayisi ? "error-form-item" : "form-control"} />

                                            </div>
                                            <div className="form-control-ctr">
                                                <select
                                                    id="kendiKuryenizVarMi"
                                                    name="kendiKuryenizVarMi"
                                                    value={formData.kendiKuryenizVarMi}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.kendiKuryenizVarMi
                                                            ? "error-form-item-select"
                                                            : "form-select"
                                                    }
                                                >
                                                    <option value="0" defaultValue='0'>Kendi kuryeniz var mı? *</option>
                                                    <option value="kendikuryemvar">Kendi kuryem var</option>
                                                    <option value="kendikuryemyok">Kendi kuryem yok</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-content w-100 row m-0 justify-content-between">
                                    <div className="col-12 col-lg-3 p-0 form-description mb-5 mb-lg-0">
                                        <h3>
                                            Kişisel Bilgiler
                                        </h3>
                                        <span>Lütfen kurumsal e-posta/cep telefonu bilginizi giriniz.</span>
                                    </div>
                                    <div className="col-12 col-lg-7 p-0 form-items d-flex flex-column">
                                        <div className="form-items-secondary">
                                            <div className="form-control-ctr">
                                                <input
                                                    type="text"
                                                    placeholder="Ad *"
                                                    id="firstName"
                                                    name="firstName"
                                                    value={formData.firstName}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.firstName ? "error-form-item" : "form-control"
                                                    }
                                                />
                                            </div>
                                            <div className="form-control-ctr">
                                                <input
                                                    type="text"
                                                    placeholder="Soyad *"
                                                    id="lastName"
                                                    name="lastName"
                                                    value={formData.lastName}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.lastName ? "error-form-item" : "form-control"
                                                    }
                                                />
                                            </div>
                                            <div className="form-control-ctr">
                                                <InputMask
                                                    type="gsm"
                                                    mask="999 999 99 99"
                                                    placeholder="Cep Telefonu *"
                                                    id="gsm"
                                                    name="gsm"
                                                    value={formData.gsm}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.gsm ? "error-form-item" : "form-control"
                                                    }
                                                />

                                            </div>
                                        </div>

                                        <div className="form-items">
                                            <div className="form-control-ctr">
                                                <InputMask
                                                    type="tckn"
                                                    mask="99999999999"
                                                    placeholder="TC Kimlik No *"
                                                    id="tc"
                                                    name="tc"
                                                    value={formData.tc}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.tc ? "error-form-item" : "form-control"
                                                    }
                                                />
                                                {errors.tc && <small className="error-text">Geçersiz Kimlik Numarası</small>}
                                            </div>

                                            <div className="form-control-ctr">
                                                <input
                                                    type="email"
                                                    placeholder="E-posta *"
                                                    id="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    className={
                                                        errors.email ? "error-form-item" : "form-control"
                                                    }
                                                />
                                            </div>

                                        </div>



                                    </div>

                                </div>

                                <div className="form-content w-100 row m-0 justify-content-between border-0">
                                    <div className="col-12 col-lg-3 p-0 form-description mb-5 mb-lg-0">
                                        <h3>
                                            Bizi Nereden Gördünüz
                                        </h3>

                                    </div>


                                    <div className="col-12 col-lg-7 p-0 form-items d-flex flex-column">

                                        <div className="form-items w-100  d-flex">
                                            <div className="form-control-ctr">
                                                <select
                                                    id="referans"
                                                    name="referans"
                                                    value={formData.referans}
                                                    className={
                                                        errors.referans
                                                            ? "error-form-item-select"
                                                            : "form-select"
                                                    }
                                                    onChange={handleInputChange}
                                                >
                                                    <option value='0' defaultValue='0'>Bizi Nereden Gördünüz *</option>
                                                    <option value="Web Sitesi">Web Sitesi</option>
                                                    <option value="Instagram">Instagram</option>
                                                    <option value="Linkedin">Linkedin</option>
                                                    <option value="Facebook">Facebook</option>
                                                    <option value="Twitter">Twitter</option>
                                                    <option value="Kurye Referansı">Kurye Referansı</option>
                                                    <option value="İşletme Referansı">İşletme Referansı</option>
                                                    <option value="Satış Temsilcisi">Satış Temsilcisi</option>
                                                </select>
                                            </div>
                                        </div>

                                        {(formData.referans === "Kurye Referansı" || formData.referans === "Satış Temsilcisi" ||
                                            formData.referans === "İşletme Referansı") && (
                                                <div className="form-control-ctr">
                                                    <input
                                                        type="text"
                                                        placeholder={formData.referans === "İşletme Referansı" ? "İşletme Adı / Adı Soyadı *" : "Adı Soyadı *"}
                                                        id="referansAdSoyad"
                                                        name="referansAdSoyad"
                                                        value={formData.referansAdSoyad}
                                                        onChange={handleInputChange}
                                                        className={
                                                            errors.referansAdSoyad
                                                                ? "error-form-item"
                                                                : "form-control"
                                                        }
                                                    />
                                                </div>
                                            )}
                                    </div>
                                </div>

                                <div
                                    className="kvkk-onay"

                                >
                                    <button
                                        type="button"
                                        className={cx("disabledButton", {
                                            "error-form-item-button": errors.gdpr,
                                        })}
                                        onClick={() => {
                                            setFormData({ ...formData, gdpr: !formData.gdpr });
                                            setErrors({ ...errors, gdpr: false });
                                        }}
                                    >
                                        {formData.gdpr ? (
                                            <img src="/images/button-selected.svg" alt="" />
                                        ) : (
                                            <img src="/images/button-disabled.svg" alt="" />
                                        )}
                                    </button>
                                    <span>
                                        <input
                                            type="checkbox"
                                            className="kvkkCheckbox"
                                            style={{ display: "none" }}
                                            name="gdpr"
                                            onChange={handleInputChange}
                                        />
                                        <label className="ms-4">
                                        <NavLink to="/files/Fiyuu-is-Ortagi-Aydinlatma-Metni.pdf" target="_blank">
                                                Aydınlatma Metnimize buradan ulaşabilirsiniz.
                                            </NavLink>
                                        </label>
                                    </span>
                                </div>


                                <div
                                    className="kvkk-onay"
                                >
                                    <button

                                        className={cx("disabledButton", {
                                            "error-form-item-button": errors.kvkk,
                                        })}
                                        type="button"
                                        onClick={() => {
                                            setFormData({ ...formData, kvkk: !formData.kvkk });
                                            setErrors({ ...errors, kvkk: false });
                                        }}
                                    >
                                        {formData.kvkk ? (
                                            <img src="/images/button-selected.svg" alt="" />
                                        ) : (
                                            <img src="/images/button-disabled.svg" alt="" />
                                        )}
                                    </button>
                                    <span>
                                        <input
                                            type="checkbox"
                                            className="kvkkCheckbox"
                                            style={{ display: "none" }}
                                            name="kvkk"
                                            onChange={handleInputChange}
                                        />
                                        <label className="ms-4">
                                        <NavLink to="/files/Fiyuu-is-Ortagi-Adayi-Acik-Riza-Metni.pdf" target="_blank">
                                            Kişisel verilerimin Açık Rıza Metni'nde belirtilen hususlar kapsamında işlenmesine onay veriyorum.
                                            </NavLink>
                                        </label>
                                    </span>
                                </div>


                                <button
                                    className="g-recaptcha submit-btn d-flex mt-5 justify-content-center align-items-center"
                                    data-sitekey="6Lf6MsUpAAAAADM2SMMV1zeYGjRCHi-nc4-NSwvF"
                                    data-callback="onSubmit"
                                    data-action="submit"
                                >
                                    <span className="text-center d-inline-block">
                                        Hemen Başvur
                                    </span>
                                </button>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Partner;